module.exports = __webpack_public_path__ + "img/icon-pessoa-padrao.a652e97b.svg";